export enum PlanSlug {
  FREE = 'free',
  STARTER = 'starter',
  BUILDER = 'builder',
  SCALE = 'scale',
}

export interface CatalogCellData {
  section?: string;
  section_order?: string;
  code: string;
  parent?: string;
  group?: string;
  order?: string;
  count?: string;
  value?: string;
  values_per_plan?: string;
  values_subtext_per_plan?: string;
  unlimited?: 'true';
  coming_soon?: 'true';
  scalable?: 'true';
  badge?: string;
  tooltip?: string;
  card_only?: 'true';
}

export interface CatalogFeatureChild {
  id: string;
  key: string;
  name: string;
  metadata: CatalogCellData;
  products: string[];
}

export interface CatalogFeature {
  key: string;
  name: string;
  metadata: CatalogCellData;
  cells: Record<string, CatalogCellData>;
  children?: CatalogFeatureChild[];
  products: string[];
  productCounts: Record<string, number>;
}

export interface CatalogProductMetadata {
  is_legacy?: string;
  is_public?: string;
  label?: string;
  order?: string;
  slug?: PlanSlug | string;
  test_product_notif?: string;
  tier?: string;
  tooltip?: string;
}

export interface CatalogProduct {
  id: string;
  name: string;
  description?: string;
  active: boolean;
  marketingFeatures?: string[];
  metadata: CatalogProductMetadata;
}

export interface FeatureCatalog {
  features: CatalogFeature[];
  products: CatalogProduct[];
}
